const publicRoutes = {
  LOGIN: '/login',
  SCHEDULESESSION: '/schedule/session',
} as const;

export type PublicRoutes = typeof publicRoutes;
export { publicRoutes };
